import React from 'react'
import { formatPhoneNumber } from '../../utilities/stringUtilities'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
export default function ServiceRequestDetails ({
  toggleDetails,
  request,
  buttonView
}) {
  const service = request[0]
  return (
    <div className='bg-white h-full w-full absolute top-0 left-0 z-50 overflow-y-auto'>
      <div className='bg-gray-light font-size-1-5em p-4'>
        <button
          className='mr-2'
          onClick={() => toggleDetails(false)}>
          <i className='material-icons relative top-2'>arrow_back</i>
        </button>
        <span>{`${service.ticketType.name} (${request.length}) on `}</span>
        <span className='font-medium'>{dayjs(service.serviceDate).format('M/D/YYYY')}</span>
      </div>
      <div>
        <div className='flex flex-row flex-wrap px-8 mt-4'>
          <div className='w-full flex text-gray'>
            Customer Contact
          </div>
          <div className='w-full leading-6 mb-4'>
            <p>{service.firstName} {service.lastName}</p>
            <p>{formatPhoneNumber(service.primaryPhone)}</p>
            <p>{service.email}</p>
          </div>
          <div className='w-full text-gray'>Address</div>
          <div className='w-full leading-6 mb-4'>
            <span>{service.addressline1}, {service.city}, {service.state} {service.zip}</span>
            {service.addressDetails && <span>{`(${service.addressDetails})`}</span>}
          </div>
          <div className='w-full flex text-gray'>
            Project Needs
          </div>
          <div className='w-full flex leading-6 mb-4'>
            Project Type: {service.projectType.join()}
          </div>
          <div className='w-full flex leading-6 mb-4'>
            Expected Material Types: {service.materials.join()}
          </div>
          { service.status === 'PENDING_RESOLUTION' && (
            <>
              <div className='w-full flex text-gray'>
                Reason for Service Modification
              </div>
              <div className='w-full flex leading-6 mb-4'>
                {service.issueNotes}
              </div>
            </>
          )}
        </div>
      </div>
      <div className='mt-8 pr-8'>
        {buttonView()}
      </div>
      <div className='text-center font-medium font-size-1-5em pt-6 pb-4 border-b border-gray-light'>
        {`Asset Needs (${request.length})`}
      </div>
      {request.map((ticket, index) => (
        <div className='py-6 px-8 border-b border-gray-light' key={index}>
          <div className='flex flex-row flex-nowrap justify-end'>
            <div className='mr-auto font-medium font-size-1-25em'>
              {ticket.resourceType.name} ({ticket.resourceType.shortCode})
            </div>
            {ticket.requestedStartTime && ticket.requestedEndTime &&
              <>
                <i className='material-icons text-gray-md-dark font-size-1-25em my-auto px-2'>schedule</i>
                <div className='text-gray-md-dark my-auto text-2xl'>
                  {`${dayjs.utc(ticket.requestedStartTime).format('h:mm a')} - ${dayjs.utc(ticket.requestedEndTime).format('h:mm a')}`}
                </div>
              </>}
          </div>
          <div className='text-gray'>
            {ticket.serviceNotes}
          </div>
        </div>
      ))}
    </div>
  )
}

ServiceRequestDetails.propTypes = {
  request: PropTypes.object.isRequired,
  toggleDetails: PropTypes.func.isRequired,
  buttonView: PropTypes.func.isRequired
}
